module.exports = {"510504001":"小市街道","510504002":"高坝街道","510504003":"红星街道","510504004":"莲花池街道","510504005":"罗汉街道","510504006":"鱼塘街道","510504007":"安宁街道","510504008":"石洞街道","510504009":"特兴街道","510504103":"胡市镇","510504106":"双加镇","510504107":"金龙镇","510504108":"长安镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510504.json
// module id = 2288
// module chunks = 0